var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.9944C23 11.7142 22.8869 11.4565 22.6607 11.2436L15.1632 3.83619C14.9143 3.58965 14.6769 3.5 14.4055 3.5C13.8514 3.5 13.4216 3.90343 13.4216 4.46374C13.4216 4.73269 13.5121 4.99044 13.6931 5.16974L16.2262 7.72477L20.7156 11.7815L20.9418 11.2211L17.3005 10.997H2.99515C2.40711 10.997 2 11.4116 2 11.9944C2 12.5771 2.40711 12.9917 2.99515 12.9917H17.3005L20.9418 12.7676L20.7156 12.2185L16.2262 16.2639L13.6931 18.819C13.5121 18.9871 13.4216 19.2561 13.4216 19.5249C13.4216 20.0853 13.8514 20.4888 14.4055 20.4888C14.6769 20.4888 14.9143 20.3879 15.1406 20.1749L22.6607 12.7452C22.8869 12.5323 23 12.2745 23 11.9944Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.900108aaac742fdb7f37ffa28f77660e.svg";
export { ForwardRef as ReactComponent };